import { render, staticRenderFns } from "./SingleItem.vue?vue&type=template&id=17cd69ec&"
import script from "./SingleItem.vue?vue&type=script&lang=js&"
export * from "./SingleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/22413/203/Snaply5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17cd69ec')) {
      api.createRecord('17cd69ec', component.options)
    } else {
      api.reload('17cd69ec', component.options)
    }
    module.hot.accept("./SingleItem.vue?vue&type=template&id=17cd69ec&", function () {
      api.rerender('17cd69ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/snaply/SingleItem.vue"
export default component.exports